import React from 'react';
import PropTypes from 'prop-types';
import { InfoMessage } from '@fasstech/middle-design-system';
import getMessageInfo from '@@viewHelpers/getMessageInfo.js';
import getExtraRecapitulatifMessageInfo from '../extra/getExtraRecapitulatifMessageInfo.js';
import { isNilOrEmpty } from '@@serverHelpers';

export const SummaryFooter = ({ getMiddleText, subscriptionStatus }) => {
  const extraMessage = getExtraRecapitulatifMessageInfo(getMiddleText);

  if (isNilOrEmpty(extraMessage)) {
    return null;
  }

  return (
    <InfoMessage iconName={'lightbulb'}>
      <div
        dangerouslySetInnerHTML={{
          __html: getMessageInfo(extraMessage, subscriptionStatus)
        }}
      />
    </InfoMessage>
  );
};

SummaryFooter.propTypes = {
  getMiddleText: PropTypes.func.isRequired,
  subscriptionStatus: PropTypes.string
};
